import React, { useState, useEffect } from 'react';
import Header from '../../components/Header/Header';
import NavInf from '../../components/NavInf/NavInf';
import Footer from '../../components/Footer/Footer';
import { Link } from 'react-router-dom';
import WhatsAppBtn from '../../components/WhatsAppBtn/WhatsAppBtn.js';
import './Categories.css';

const Categories = () => {
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch('https://api.minymol.com/categories/with-products-and-images');
                const data = await res.json();

                if (Array.isArray(data)) {
                    setCategories(data);
                    if (data.length > 0) {
                        setSelectedCategoryId(data[0].id);
                    }
                } else {
                    console.error('La respuesta no es un array:', data);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchData();
    }, []);


    const filteredSubCategories = categories.find(cat => cat.id === selectedCategoryId)?.subCategories || [];

    return (
        <>
            <Header />
            <div className="categories-container">
                <aside className="sidebar">
                    <ul>
                        {categories.map((cat) => (
                            <li
                                key={cat.id}
                                id={selectedCategoryId === cat.id ? 'selected-cat' : undefined}
                                onClick={() => setSelectedCategoryId(cat.id)}
                            >
                                {cat.name}
                            </li>
                        ))}
                    </ul>
                </aside>
                <section className="categories-main">
                    <div className="category-grid">
                        {filteredSubCategories.map((sub) => (
                            <Link
                                to={`/sub-category/${sub.slug}`}
                                key={sub.id}
                                className="category-item"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                                <div className="circle-image">
                                    <img src={sub.imageUrl} alt={sub.name} />
                                </div>
                                <span>{sub.name}</span>
                            </Link>
                        )
                        )}
                    </div>

                </section>
            </div>
            <WhatsAppBtn />
            <NavInf selected="categories" />
            <Footer navinf={true} />
        </>
    );
};

export default Categories;
